
export class DocumentApprovalItem {
  documentApprovalId: number;
  documentQueueId: number;
  chaseId: number;
  currentDocumentApprovalStateID: number;
  approvalStatusDirectoryUserID: number;

  constructor(options: {
    documentApprovalId: number;
    documentQueueId: number;
    chaseId: number;
    currentDocumentApprovalStateID: number;
    approvalStatusDirectoryUserID: number;
  }) {

    this.documentApprovalId = options.documentApprovalId;
    this.documentQueueId = options.documentQueueId;
    this.chaseId = options.chaseId;
    this.currentDocumentApprovalStateID = options.currentDocumentApprovalStateID;
    this.approvalStatusDirectoryUserID = options.approvalStatusDirectoryUserID;
  }
}

